import { Button } from "./ui/button";
import { ArrowLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";

const RobotPageNav = () => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <Button asChild variant="ghost" size="sm">
        <Link to="/robots">
          <ArrowLeft className="mr-2 w-4 h-4" />
          <span className="hidden sm:inline">All Robots</span>
          <span className="sm:hidden">Robots</span>
        </Link>
      </Button>
      <Button asChild variant="ghost" size="sm">
        <Link to="/">
          <Home className="mr-2 w-4 h-4" />
          <span className="hidden sm:inline">Home Page</span>
          <span className="sm:hidden">Home</span>
        </Link>
      </Button>
    </div>
  );
};

export default RobotPageNav;
